/* 获取元素高度 */
function getStyle(obj, attr) {
	if (obj.currentStyle) {
		return obj.currentStyle[attr];
	}
	return document.defaultView.getComputedStyle(obj, null)[attr];
}

function getElementHeight(el) {
	return el ? Number(el.offsetHeight) + Number(getStyle(el, 'margin-top').replace(/px/g, '')) + Number(getStyle(el, 'margin-bottom').replace(/px/g, '')) : 0;
}

export default function computedElementHeight(prevFilterValue, ...elements) {
	return elements.reduce((accumulator, currentElement) => accumulator + getElementHeight(currentElement), 0);
}
